// extracted by mini-css-extract-plugin
module.exports = {"content":"HowItWorksBlock_content__H4hjh","open":"HowItWorksBlock_open__80uNf","close":"HowItWorksBlock_close__NH5zN"};